import { useMemo, forwardRef, useRef, Ref } from "react";

import * as THREE from "three";

import { RADIUS, RENDER_ORDER } from "@graphic/constants";
import { getEarthRotationAngle } from "@graphic/utils";
import { useFrame } from "@react-three/fiber";
import { useTimeStore } from "@graphic/stores";

type EarthProps = {
  map: string;
  bump: string;
  clouds: string;
};

const Earth = forwardRef(
  (
    props: EarthProps,
    ref: React.ForwardedRef<THREE.Object3D<THREE.Object3DEventMap>>
  ) => {
    const { map, bump } = props;
    const mapTexture = useMemo(
      () => new THREE.TextureLoader().load(map),
      [map]
    );
    const bumpTexture = useMemo(
      () => new THREE.TextureLoader().load(bump),
      [bump]
    );

    const meshRef = useRef<THREE.Mesh>(null);

    useFrame(() => {
      if (!meshRef.current) return;
      const time = useTimeStore.getState().time;
      const earthRotationAngle = getEarthRotationAngle(time);
      meshRef.current.rotation.y = earthRotationAngle;
    }, RENDER_ORDER.OBJECT);

    return (
      <group
        ref={ref as Ref<THREE.Group<THREE.Object3DEventMap>>}
        onClick={e => e.stopPropagation()}
        onPointerDown={e => e.stopPropagation()}
        onPointerUp={e => e.stopPropagation()}
        onPointerOver={e => e.stopPropagation()}
        onPointerOut={e => e.stopPropagation()}
        onPointerEnter={e => e.stopPropagation()}
        onPointerLeave={e => e.stopPropagation()}
        onPointerMove={e => e.stopPropagation()}
        onDoubleClick={e => e.stopPropagation()}
      >
        <mesh ref={meshRef} rotation-x={Math.PI / 2}>
          {/* <mesh ref={meshRef} rotation-x={Math.PI / 2} rotation-y={earthRotationAngle}> */}
          <sphereGeometry attach="geometry" args={[RADIUS, 75, 75]} />
          <meshLambertMaterial
            attach="material"
            map={mapTexture}
            bumpMap={bumpTexture}
            bumpScale={1}
          />
        </mesh>
      </group>
    );
  }
);

export default Earth;
